import React, { memo } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { MDBRow, MDBCol } from "mdbreact";

import { Label, TextArea } from "abs-ui-components";

const CommentsFormGroup = (props) => {
	const { control } = useFormContext();

	return (
		<div className="container-fluid p-0 m-0">
			<MDBRow>
				<MDBCol className="mt-3">
					<Label bold name="Remarks" className="mb-1" />
					<Controller
						name="vesselIdentifications.comments"
						control={control}
						defaultValue={
							props.vesselMstId ? props.vesselData?.Remarks : ""
						}
						render={({ field }) => (
							<TextArea
								id="vessel_comment"
								className="textarea-resize"
								value={field?.value || ""}
								onChange={field.onChange}
								rows={11}
								readOnly={
									!props.isEnrollVessel &&
									props.vesselMstId &&
									(props?.regulations?.trim() === "EUMRV" ||
										"UKMRV" ||
										"DCS")
								}
							/>
						)}
					/>
				</MDBCol>
			</MDBRow>
		</div>
	);
};

export default memo(CommentsFormGroup);
